// extracted by mini-css-extract-plugin
export default {"header":"Header_header__aYTGa","logoContainer":"Header_logoContainer__F9RNg","logoImage":"Header_logoImage__-VitD","logo":"Header_logo__e139J","burger":"Header_burger__mwlxY"};